import api from '~api'
import {
  convertPages,
  convertMedia
} from '~utils/api'

export const url = `/news`

const newsType = [
  {
    color: 'pink',
    text: '實習資訊'
  },
  {
    color: 'yellow',
    text: '徵才快報'
  },
  {
    color: 'blue',
    text: '活動公告'
  },
  {
    color: 'green',
    text: '一般訊息'
  }
]

export async function getNews ({
  type,
  page
}) {
  const {
    data
  } = await api.get(url, {
    params: {
      type,
      page
    }
  })

  const news = data.data.map((pieceNews) => {
    return {
      news_id: pieceNews.id,
      news_published_at: pieceNews.start_date,
      news_type: pieceNews.type,
      news_type_color: newsType[pieceNews.type - 1].color,
      news_type_text: newsType[pieceNews.type - 1].text,
      news_topic: pieceNews.title,
      news_is_pinned: !!pieceNews.top,
      news_pinned_rank: pieceNews.top
    }
  })

  const pages = convertPages(data.meta)

  return ({
    news: news.sort((prev, next) => next.news_pinned_rank - prev.news_pinned_rank),
    pages
  })
}

export async function getNewsById (id) {
  const {
    data
  } = await api.get(`${url}/${id}`)

  const response = data.data

  const news = {
    news_id: response.id,
    news_published_at: response.start_date,
    news_type: response.type,
    news_type_color: newsType[response.type - 1].color,
    news_type_text: newsType[response.type - 1].text,
    news_topic: response.title,
    news_content: response.content,
    news_attachments: convertMedia(response.media)
  }
  return (news)
}
